import type { TFunction } from 'i18next';

import { dayShort } from '../../lib/format';
import type { SkyDay } from '../../lib/sky';

/** The moon of a day it is seen, shortly: its shape, when it rises that day and sets — `Poolkuu
 * 11:36–00:05` `+1`, the day picked saying which; with no rise that day, the day before said once
 * before it: `Kasvav kuu 3. okt 23:56–13:21` `+1`. */
export function moonOf(
  sky: SkyDay,
  day: string,
  t: TFunction,
  language: string,
): { said: string; later: string } {
  const shape = t(`calendar.moonShape.${sky.shape}`);
  // Up all day and night, as far north as it may be: no time to it. Risen and not set again by
  // the next day's end: when it rises, and that it stays up.
  if (sky.moonAllDay || sky.moonrise === '—')
    return { said: t('calendar.moonAllDay', { shape }), later: '' };
  if (sky.moonset === '—') {
    return { said: t('calendar.moonStays', { shape, rise: sky.moonrise }), later: '' };
  }
  const risen = new Date(Date.parse(`${day}T00:00:00Z`) + sky.riseDays * 86_400_000)
    .toISOString()
    .slice(0, 10);
  // Set on a later day: how many after, raised beside it — `+1`.
  return {
    said: t('calendar.moonUp', {
      shape,
      rise: sky.riseDays === 0 ? sky.moonrise : `${dayShort(risen, language)} ${sky.moonrise}`,
      set: sky.moonset,
    }),
    later: sky.setDays === 0 ? '' : `+${String(sky.setDays)}`,
  };
}
